<header class="plc-dialog__header">
	<div></div>
	<plc-label [title]="title" [size]="'xl'" />
	<plc-icon [name]="'cross'" [hover]="true" (click)="close()" />
</header>

<main #main class="plc-dialog__main">
	<ng-content></ng-content>
</main>
